import useCatalog from '@/hooks/useCatalog';
import { NutritionTable } from './NutritionTable';
import Page from '../container/Page';
import NutritionHeroHeader from './NutritionHeroHeader';

export default () => {
  const { hierarchy } = useCatalog();
  const flatProducts = Object.values(hierarchy?.mixAndMatchBoxes ?? {}).reduce(
    (list, p) => {
      list.concat(p);
      return list;
    },
    [],
  );

  return (
    <Page variant="sage" mainClassName="" pageHeader={<NutritionHeroHeader />}>
      <NutritionTable products={hierarchy?.standardSections?.['Praline']!} />
    </Page>
  );
};
